import api from '@/api/tecnologico.api'

let servicio = {}

servicio.promocionesCon = (soloVigentes = false) => {
  return api.get(`/promociones/promocionescon/${soloVigentes}`)
}

servicio.guardar = (data) => {
  return api.post('/promociones/guardarpromocion', data)
}

servicio.cambiarEstatus = (data) => {
  return api.post('/promociones/cambiarestatuspromotion', data)
}

export default servicio
